<template>
  <div>
    <v-card class="mb-2 light-green lighten-4" @click="editCustomerClick">
      <v-card-text>
        <div class="d-flex">
          <div>
            <div>{{ item.CustomerName }}</div>
          </div>
          <v-spacer />
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-bind="attrs"
                  v-on="on"
                  @click="editCustomerClick"
                >
                  <v-icon :color="feature.customers.color">
                    {{ feature.customers.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Customer</span>
            </v-tooltip>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { ref } from 'vue'
import { feature } from '@/use/Constants'
export default {
  name: 'CustomerListItemCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const initForm = async () => {
      await loadSelectLists()
    }

    const loadSelectLists = async () => {}

    const editCustomerClick = () => {
      context.emit('edit', props.item.CustomerId)
    }

    initForm()
    return {
      feature,
      editCustomerClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
